import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "an" }
const _hoisted_2 = { class: "an-header" }
const _hoisted_3 = { class: "an-range" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = {
  key: 0,
  class: "an-loading"
}
const _hoisted_6 = { class: "an-cards" }
const _hoisted_7 = { class: "an-card" }
const _hoisted_8 = { class: "an-card-value" }
const _hoisted_9 = { class: "an-card" }
const _hoisted_10 = { class: "an-card-value" }
const _hoisted_11 = { class: "an-card" }
const _hoisted_12 = { class: "an-card-value" }
const _hoisted_13 = { class: "an-card" }
const _hoisted_14 = { class: "an-card-value" }
const _hoisted_15 = {
  key: 0,
  class: "an-empty"
}
const _hoisted_16 = { class: "an-block" }
const _hoisted_17 = { class: "an-chart" }
const _hoisted_18 = ["title"]
const _hoisted_19 = { class: "an-bar-day" }
const _hoisted_20 = { class: "an-grid" }
const _hoisted_21 = { class: "an-block" }
const _hoisted_22 = { class: "an-row-label" }
const _hoisted_23 = { class: "an-row-bar" }
const _hoisted_24 = { class: "an-row-val" }
const _hoisted_25 = { class: "an-block" }
const _hoisted_26 = { class: "an-row-label" }
const _hoisted_27 = { class: "an-row-bar" }
const _hoisted_28 = { class: "an-row-val" }
const _hoisted_29 = { class: "an-block" }
const _hoisted_30 = ["title"]
const _hoisted_31 = { class: "an-row-bar" }
const _hoisted_32 = { class: "an-row-val" }
const _hoisted_33 = { class: "an-block" }
const _hoisted_34 = { class: "an-row-label an-cap" }
const _hoisted_35 = { class: "an-row-bar" }
const _hoisted_36 = { class: "an-row-val" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[0] || (_cache[0] = _createElementVNode("h2", { class: "an-title" }, "Website Analytics", -1)),
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.ranges, (opt) => {
          return (_openBlock(), _createElementBlock("button", {
            key: opt.days,
            class: _normalizeClass(["an-range-btn", { active: _ctx.days === opt.days }]),
            onClick: ($event: any) => (_ctx.setRange(opt.days))
          }, _toDisplayString(opt.label), 11, _hoisted_4))
        }), 128))
      ])
    ]),
    (_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, "Loading analytics…"))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _cache[1] || (_cache[1] = _createElementVNode("div", { class: "an-card-label" }, "Total Page Views", -1)),
              _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.stats.total_visits.toLocaleString()), 1)
            ]),
            _createElementVNode("div", _hoisted_9, [
              _cache[2] || (_cache[2] = _createElementVNode("div", { class: "an-card-label" }, "Unique Visitors", -1)),
              _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.stats.unique_visitors.toLocaleString()), 1)
            ]),
            _createElementVNode("div", _hoisted_11, [
              _cache[3] || (_cache[3] = _createElementVNode("div", { class: "an-card-label" }, "Top Country", -1)),
              _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.topCountry), 1)
            ]),
            _createElementVNode("div", _hoisted_13, [
              _cache[4] || (_cache[4] = _createElementVNode("div", { class: "an-card-label" }, "Top Source", -1)),
              _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.topSource), 1)
            ])
          ]),
          (_ctx.stats.total_visits === 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_15, " No visits recorded yet for this period. Once the site is live and people browse it, data will appear here automatically. "))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createElementVNode("div", _hoisted_16, [
                  _cache[5] || (_cache[5] = _createElementVNode("h3", { class: "an-block-title" }, "Visits per day", -1)),
                  _createElementVNode("div", _hoisted_17, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.stats.daily, (d, i) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: i,
                        class: "an-bar-wrap",
                        title: `${d.day}: ${d.views}`
                      }, [
                        _createElementVNode("div", {
                          class: "an-bar",
                          style: _normalizeStyle({ height: _ctx.barHeight(d.views) })
                        }, null, 4),
                        _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.shortDay(d.day)), 1)
                      ], 8, _hoisted_18))
                    }), 128))
                  ])
                ]),
                _createElementVNode("div", _hoisted_20, [
                  _createElementVNode("div", _hoisted_21, [
                    _cache[6] || (_cache[6] = _createElementVNode("h3", { class: "an-block-title" }, "Top countries", -1)),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.stats.by_country, (row) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: row.country,
                        class: "an-row"
                      }, [
                        _createElementVNode("span", _hoisted_22, _toDisplayString(_ctx.flag(row.country)) + " " + _toDisplayString(row.country), 1),
                        _createElementVNode("div", _hoisted_23, [
                          _createElementVNode("div", {
                            style: _normalizeStyle({ width: _ctx.pct(row.views, _ctx.stats.by_country) })
                          }, null, 4)
                        ]),
                        _createElementVNode("span", _hoisted_24, _toDisplayString(row.views), 1)
                      ]))
                    }), 128))
                  ]),
                  _createElementVNode("div", _hoisted_25, [
                    _cache[7] || (_cache[7] = _createElementVNode("h3", { class: "an-block-title" }, "Where visitors come from", -1)),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.stats.by_source, (row) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: row.source,
                        class: "an-row"
                      }, [
                        _createElementVNode("span", _hoisted_26, _toDisplayString(row.source), 1),
                        _createElementVNode("div", _hoisted_27, [
                          _createElementVNode("div", {
                            style: _normalizeStyle({ width: _ctx.pct(row.views, _ctx.stats.by_source) })
                          }, null, 4)
                        ]),
                        _createElementVNode("span", _hoisted_28, _toDisplayString(row.views), 1)
                      ]))
                    }), 128))
                  ]),
                  _createElementVNode("div", _hoisted_29, [
                    _cache[8] || (_cache[8] = _createElementVNode("h3", { class: "an-block-title" }, "Most visited pages", -1)),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.stats.top_pages, (row) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: row.path,
                        class: "an-row"
                      }, [
                        _createElementVNode("span", {
                          class: "an-row-label",
                          title: row.path
                        }, _toDisplayString(row.path), 9, _hoisted_30),
                        _createElementVNode("div", _hoisted_31, [
                          _createElementVNode("div", {
                            style: _normalizeStyle({ width: _ctx.pct(row.views, _ctx.stats.top_pages) })
                          }, null, 4)
                        ]),
                        _createElementVNode("span", _hoisted_32, _toDisplayString(row.views), 1)
                      ]))
                    }), 128))
                  ]),
                  _createElementVNode("div", _hoisted_33, [
                    _cache[9] || (_cache[9] = _createElementVNode("h3", { class: "an-block-title" }, "Devices", -1)),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.stats.by_device, (row) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: row.device,
                        class: "an-row"
                      }, [
                        _createElementVNode("span", _hoisted_34, _toDisplayString(row.device), 1),
                        _createElementVNode("div", _hoisted_35, [
                          _createElementVNode("div", {
                            style: _normalizeStyle({ width: _ctx.pct(row.views, _ctx.stats.by_device) })
                          }, null, 4)
                        ]),
                        _createElementVNode("span", _hoisted_36, _toDisplayString(row.views), 1)
                      ]))
                    }), 128))
                  ])
                ])
              ], 64))
        ], 64))
  ]))
}